<div class="mt-4 mx-4">
  <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

  <div class="card shadow-sm border-0 mt-4">
    <div class="card-body p-4">
      <!-- Header Section -->
      <!-- <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 class="mb-1 fw-bold text-dark">Risk & Compliance Reports</h4>
          <p class="text-muted mb-0 small">Generate comprehensive financial and compliance reports</p>
        </div>
        <div class="d-flex align-items-center gap-2 justify-content-between">
          <span class="badge bg-light text-dark border">
            <i class="bi bi-clock-history me-1"></i>
            {{ getCurrentDate() }}
          </span>
        </div>
      </div> -->

      <!-- Search & Filter Bar -->
      <div class="row align-items-center mb-4">
        <div class="col-md-9 col-sm-12 mb-2 mb-md-0">
          <div class="position-relative">
            <input 
              type="text" 
              class="form-control user-search-input shadow-none"
              placeholder="Search reports..."
              [(ngModel)]="searchTerm"
              (input)="filterReports()">
            <span class="search-icon" (click)="filterReports()">
              <i class="bi bi-search"></i>
            </span>
          </div>
        </div>
        <div class="col-md-3 col-sm-12 text-md-end text-start">
          <button class="btn btn-secondary btn-sm" (click)="resetSearch()">
            <i class="bi bi-arrow-clockwise me-1"></i> Reset
          </button>
        </div>
      </div>

      <!-- Report Tiles Grid -->
      <div class="row g-4">
        <div class="col-xl-3 col-lg-4 col-md-6" *ngFor="let report of filteredReportTypes">
          <div class="report-card card-glow" (click)="openReportFilter(report)" role="button" tabindex="0"
               (keypress)="handleKeyPress($event, report)">
            <div class="report-card-inner">
              <div class="icon-wrapper" [style.background]="report.color">
                <i [class]="report.icon"></i>
              </div>
              <div class="report-content">
                <h6 class="report-title">{{ report.name }}</h6>
                <p class="report-description">{{ report.description }}</p>
              </div>
              <div class="report-arrow">
                <i class="bi bi-arrow-right-circle"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- No Results -->
      <div *ngIf="filteredReportTypes.length === 0" class="text-center py-5">
        <i class="bi bi-inbox" style="font-size: 4rem; color: #dee2e6;"></i>
        <p class="text-muted mt-3 mb-0">No reports found matching your search</p>
      </div>
    </div>
  </div>
</div>

<!-- Filter Offcanvas -->
<div class="offcanvas offcanvas-end" 
     style="width: 650px;"
     tabindex="-1" 
     id="reportFilterOffcanvas" 
     aria-labelledby="reportFilterLabel"
     data-bs-backdrop="static">
  
  <div class="offcanvas-header border-bottom bg-light">
    <div>
      <h5 class="offcanvas-title fw-bold mb-1" id="reportFilterLabel">
        <i [class]="selectedReport?.icon" class="me-2" [style.color]="selectedReport?.color"></i>
        {{ selectedReport?.name }}
      </h5>
      <p class="text-muted small mb-0">{{ selectedReport?.description }}</p>
    </div>
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body">
    <!-- Filter Form -->
    <form (ngSubmit)="generateReport()">
      <div class="mb-4">
        <label class="form-label fw-semibold">
          <i class="bi bi-building me-1"></i> Company
        </label>
        <select class="form-select form-select-lg" 
                [(ngModel)]="filter.companyId" 
                name="companyId" 
                required>
          <option [value]="undefined">All Companies</option>
          <option *ngFor="let c of companies" [value]="c.companyId">{{ c.companyName }}</option>
        </select>
      </div>

      <!-- Date Range -->
      <div class="row g-3 mb-3">
        <div class="col-6">
          <label class="form-label fw-semibold">
            <i class="bi bi-calendar-event me-1"></i> Start Date
          </label>
          <input 
            type="date" 
            class="form-control form-control-lg" 
            [(ngModel)]="filter.startDate" 
            name="startDate"
            [max]="maxStartDate"
            (change)="onStartDateChange()"
            required>
          <div class="form-text">Cannot be a future date</div>
        </div>

        <div class="col-6">
          <label class="form-label fw-semibold">
            <i class="bi bi-calendar-check me-1"></i> End Date
          </label>
          <input 
            type="date" 
            class="form-control form-control-lg" 
            [(ngModel)]="filter.endDate" 
            name="endDate"
            [min]="filter.startDate"
            [max]="maxEndDate"
            required>
          <div class="form-text">Must be after start date</div>
        </div>
      </div>

      <!-- Date Range Shortcuts -->
      <div class="mb-4">
        <label class="form-label fw-semibold d-block mb-2">Quick Select</label>
        <div class="d-flex gap-2 flex-wrap">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="setDateRange('today')">
            Today
          </button>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="setDateRange('yesterday')">
            Yesterday
          </button>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="setDateRange('week')">
            Last 7 Days
          </button>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="setDateRange('month')">
            Last 30 Days
          </button>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="setDateRange('quarter')">
            Last Quarter
          </button>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="d-grid gap-2">
        <button type="submit" 
                class="btn btn-primary btn-lg" 
                [disabled]="isLoading || !isValidDateRange()">
          <span *ngIf="!isLoading">
            <i class="bi bi-download me-2"></i> Download Excel Report
          </span>
          <span *ngIf="isLoading">
            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
            Generating...
          </span>
        </button>
        <button type="button" 
                class="btn btn-outline-secondary btn-lg" 
                (click)="resetFilter()"
                [disabled]="isLoading">
          <i class="bi bi-arrow-counterclockwise me-2"></i> Reset Filters
        </button>
      </div>
    </form>

    <!-- Info Section -->
    <div class="alert alert-info mt-4 d-flex align-items-start" role="alert">
      <i class="bi bi-info-circle me-2 mt-1"></i>
      <div>
        <strong class="d-block mb-1">Report Information</strong>
        <small>The report will be downloaded as an Excel file (.xlsx) containing all relevant data for your selected date range and company.</small>
      </div>
    </div>
  </div>
</div>